const actionType = {
    GET_ALL_REF_DATA_DD_CONFIGURATION_SUCCESS: 'GET_ALL_REF_DATA_DD_CONFIGURATION_SUCCESS',
    GET_MATCHING_RULE_NAMES_SUCCESS:'GET_MATCHING_RULE_NAMES_SUCCESS',
    GET_MATCHING_MAPPING_SUCCESS:'GET_MATCHING_MAPPING_SUCCESS',
    GET_RULE_DATA:'GET_RULE_DATA',
    GET_ALL_RULE_DATA:'GET_ALL_RULE_DATA',
    GET_PREDICTED_RULE:'GET_PREDICTED_RULE',
    GET_EXTRACTED_DATA:'GET_EXTRACTED_DATA',
};
export default actionType;